import Icon from '@/root/ui/shared/Icon'
import { IconProps } from '@/root/shared-types/ui/ui-types'
import { FC } from 'react'

export const SmartIdIcon: FC<IconProps> = ({ width = 24, height = 24, ...rest }) => (
  <Icon type="SmartId" width={width} height={height} alt="iconSmartId" ignoreRtl {...rest} />
)
